import { MatDialog, MatDialogRef, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort,MAT_DIALOG_DATA } from '@angular/material';
import { Task, TasksService } from 'src/app/services/api/tasks/tasks.service';
import { BehaviorSubject, combineLatest, from, interval, Observable, of, Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DomainService } from 'src/app/services/api/domains/domains.service';
import { TASK_CUSTOM_SEARCH_KEYS, TASK_TYPES } from 'src/app/utils/Constants';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { catchError, concatMap, debounceTime, delay, delayWhen, filter, map, startWith, switchMap, tap, toArray } from 'rxjs/operators';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AppService } from 'src/app/app.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { TaskService } from 'src/app/services/api/tasks/specific-task/task.service';
import { KeycloakService } from 'keycloak-angular';
import { OrdersService } from 'src/app/services/api/orders/orders.service';
import { ProductService } from 'src/app/services/api/product/product.service';
import { Component, Inject, OnInit,AfterViewInit,ViewChild } from '@angular/core';
import { TaskObject } from 'src/app/models/tasks/tasks-table/task-object.model';
import { TaskManagementService } from 'src/app/services/api/taskmanagement/taskmanagement.service';

export class SearchMyTasksObject {
  constructor(
    private page: number,
    private size: number,
    private userId: string,
    private roles: string[]
    ) {

    this.page = page;
    this.size = size;
    this.userId = userId
    this.roles = roles;

    }
}
enum MasterToggleState {
  CHECKED, INDETERMINATE, NOT_CHECKED
}

@Component({
  selector: 'app-my-unassigned-tasks',
  templateUrl: './my-unassigned-tasks.component.html',
  styleUrls: ['./my-unassigned-tasks.component.css']
})
export class MyUnassignedTaskComponent implements OnInit,AfterViewInit {


  dialogMyUnassinedTasksRef: MatDialogRef<MyUnassignedTaskComponent>;
  [x: string]: any;

  dataSource = new MatTableDataSource<Task>();
  expandedElement: Task | null;

  MASSIVE_MODE_LIMIT: number;
  PAGE_SIZE: number;

  limitExceeded = false;
  loading = false;
  firstSearch: boolean;

  masterToggleState: MasterToggleState;
  masterToggleStates: typeof MasterToggleState;

  doDelay: boolean;
  afterActionMessage: string;

  @ViewChild(MatPaginator, null) paginator: MatPaginator;
  @ViewChild(MatSort, null) sort: MatSort;

  basicColumns: string[] = [
    'createdon', 'domain', 'activity', 'businesscrmid',
    'taskType', 'errorCode', 'errorDescription', 'idProceso','actualOwnerId', 'queue'
  ];

  massiveColumns: string[] = [
    'selected', 'createdon', 'domain', 'activity', 'businesscrmid',
    'taskType', 'errorCode', 'errorDescription', 'idProceso'
  ];

  displayedColumns: string[];

  data: Task[] = [];
  resultsLength = 0;

  totalTasks: number;
  appData: any;

  masterToggleDisabled: boolean;

  userId: string;
  userTaskManagementRoles: string[]= [null];

  pageSize: number;
  pageIndex: number;
  sortActive: string;
  sortDirection: string;

  constructor(
    private formBuilder: FormBuilder,
    private breadcrumbsService: BreadcrumbsService,
    private domainService: DomainService,
    public dialog: MatDialog,
    private tasksService: TasksService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private taskService: TaskService,
    private notificationsService: NotificationsService,
    private keycloakService: KeycloakService,
    private ordersService : OrdersService,
    private productService : ProductService,
    private taskmanagementService : TaskManagementService,
    public dialogRef: MatDialogRef<MyUnassignedTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public dataFromTasks: any) {}

  ngOnInit() {
    this.appData = this.appService.settings;
    this.pageIndex = 0;
    this.pageSize = 20;
    this.userId = this.dataFromTasks.userId;
    this.userTaskManagementRoles = this.dataFromTasks.userRoles;
    this.displayedColumns = this.basicColumns;
  }
  ngAfterViewInit() {
    this.getMyTasks()
  }

  getMyTasks(){
    this.tasksService.getMyUnassignedTasks(new SearchMyTasksObject(this.pageIndex,this.pageSize,this.userId,this.userTaskManagementRoles)).subscribe(
      (data: any) => {
         this.loading = false;
         this.firstSearch = false;
         this.resultsLength = data.total;
         if (this.doDelay) this.paginator.length = data.total;
         this.data = data.elements;
         //this.updateRowCheckboxes();
         //this.checkMasterToggle(false);
         if (this.doDelay) {
           this.notificationsService.showNotification(this.afterActionMessage, NotificationLevel.SUCCESS);
           this.paginator.firstPage();
         }
         this.doDelay = false;
      },
      (error) => {
         this.notificationsService.showNotification(
                   "No se pudieron recuperar mis tareas: "+ error.error.errorDesc.stackTrace, NotificationLevel.ERROR
                 );
           }
     )

  }
  navigateToDetail(row: Task) {
    window.open(`${this.appData.baseUrl}${this.appData.basePath}/provision/tasks/detail?id=${row.idTask}`, '_blank');
  }
  /*private updateRowCheckboxes() {
    for (const task of this.data) {
      if (this.selectedTasks.some(selectedTask => selectedTask.idProceso === task.idProceso)) {
        task.selected = true;
      }
      else {
        task.selected = false;
      }
    }
  }*/

}
